import {
    NgbDateAdapter,
    NgbDateNativeAdapter,
    NgbTimeAdapter,
} from '@cmps/ng-bootstrap';

import {
    DateTimeDefaultLocaleProvider,
    DateTimeLocaleProvider,
} from './datetime-locale-provider';
import { TimeNativeAdapter } from './time-native-adapter';

export const DateTimeProviders = [
    { provide: NgbDateAdapter, useClass: NgbDateNativeAdapter },
    { provide: NgbTimeAdapter, useClass: TimeNativeAdapter },
    {
        provide: DateTimeLocaleProvider,
        useClass: DateTimeDefaultLocaleProvider,
    },
];
